"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onboardingAccountFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const onboardingAccountRequirementsFactory = Factory.Sync.makeFactory({
    alternatives: [],
    current_deadline: Factory.each(() => new Date().toISOString()),
    currently_due: [],
    disabled_reason: 'none',
    errors: [],
    eventually_due: [],
    past_due: [],
    pending_verification: []
});
exports.onboardingAccountFactory = Factory.Sync.makeFactory({
    tenant_key: Factory.each(() => uuid_1.v4()),
    approved: false,
    auto_payouts: false,
    business_profile: {},
    company: {},
    customer_pays_fee: false,
    email: Factory.each(i => `user${i}@example.com`),
    financial_contact_email: Factory.each(i => `finance${i}@example.com`),
    financial_contact_name: 'John Doe',
    fiscal_start_date: Factory.each(() => new Date().toISOString().split('T')[0]),
    onboarding_user_id: Factory.each(() => uuid_1.v4()),
    reference_id: Factory.each(i => i),
    requirements: onboardingAccountRequirementsFactory.build(),
    statement_descriptor: 'Test Descriptor',
    status: 'pending',
    transaction_fee: '2.9%',
    variable_rate: '1.5%',
    under_review: false,
    merchant_account_id: Factory.each(i => i),
    payouts_enabled: false,
    charges_enabled: false,
    clare_account: false,
    persons: [],
    external_account: {}
});
